require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-81-requesting-progress-updates.json") })
        }
      }, "path---article-81-requesting-progress-updates");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-81-requesting-progress-updates!./.cache/json/article-81-requesting-progress-updates.json
// module id = 570
// module chunks = 231608221292675